import React, { FC } from 'react';

import {
  Modal,
  ModalContent,
  ModalHeader,
  ModalTitle,
  ModalFooter
} from '@epoch-ui/components/Modal/modal';
import { Button } from '@epoch-ui/components/Button';
import { Icon } from '@epoch-ui/components/Icon';
import LoadingSpinner from 'components/common/loaders/LoadingSpinner';

import AIBetaPill from '../../AIBetaPill';

import EventDescriptionAISteps from './EventDescriptionAISteps';

interface EventDescriptionConfirmProps extends React.ComponentProps<typeof Modal> {
  description: string;
  handleSubmit: () => void;
  handleBack: () => void;
}

/**
 * AI modal prompts for Event description.
 * Last step: Display generated description.
 * @param param0
 * @returns
 */
const EventDescriptionConfirm: FC<React.PropsWithChildren<EventDescriptionConfirmProps>> = ({
  handleSubmit,
  handleBack,
  description,
  open: isOpen,
  onOpenChange: onRequestClose,
  ...props
}) => {
  return (
    <Modal open={isOpen} onOpenChange={(open) => !open && onRequestClose?.(false)} {...props}>
      <ModalContent size="md" className="tw-max-w-[556px]">
        <ModalHeader>
          <div className="tw-flex tw-flex-col tw-items-start">
            <AIBetaPill />
            <ModalTitle>Here&apos;s your description</ModalTitle>
          </div>
        </ModalHeader>

        <div
          className=" tw-flex tw-h-full tw-min-h-[120px] tw-overflow-y-scroll tw-rounded-lg tw-border-solid tw-border-border-grey tw-p-4
      "
        >
          {description ? (
            <div dangerouslySetInnerHTML={{ __html: description }} />
          ) : (
            <div className="tw-ml-[auto] tw-mr-[auto] tw-flex tw-items-center tw-justify-center">
              <LoadingSpinner />
            </div>
          )}
        </div>
        <div className="tw-mt-3 tw-text-xs tw-font-normal tw-text-primary-grey">
          AI-generated content may not be fully accurate.&nbsp;
          <a
            href="https://help.epochapp.com/articles/ai-tools"
            target="_blank"
            rel="noopener noreferrer"
            className="tw-text-xs tw-font-normal tw-text-primary-grey tw-underline"
          >
            Learn more
          </a>
        </div>

        <ModalFooter className="tw-justify-between sm:tw-justify-between">
          <EventDescriptionAISteps step={4} />
          <div className="tw-flex tw-gap-2">
            <Button variant="secondary" onClick={handleBack}>
              Back
            </Button>
            <Button variant="primary" onClick={handleSubmit} disabled={!description}>
              Add description
              <Icon name="plus" size={16} className="tw-ml-2" />
            </Button>
          </div>
        </ModalFooter>
      </ModalContent>
    </Modal>
  );
};

export default EventDescriptionConfirm;
